<main class="profile-layout container">
  <section class="profile-layout__container">
    <router-outlet></router-outlet>
  </section>
</main>
